module.exports = __webpack_public_path__ + "img/执行中延期.e0c8f4ed.svg";